import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../modules/config/config.service';

/**
 * Service for IAM OBO on-behalf-of. Used in ADFS2019.
 */
@Injectable()
export class IamoboService {

    iamoboUrl: string;
    webApiKey: string;
    accessToken: string;

    constructor(private http: HttpClient, private configService: ConfigService) {

        this.configService.load().subscribe(config => {

            this.iamoboUrl = config.apiUrl.iamobo;
            this.webApiKey = config.webApiKey;

            this.accessToken = sessionStorage.getItem('accessToken');
        });
    }

    public setUserContext(userId: string, oboCluid: string): Observable<any> {

        return this.http.post<any>(this.iamoboUrl + `/user/${userId}`,
            {cluid: oboCluid},
            {headers: this.headers()});
    }

    private headers(): HttpHeaders {

        return new HttpHeaders()
            .set('Authorization', 'Bearer' + ' ' + this.accessToken)
            .append('WEB-API-Key', this.webApiKey);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/services/iamobo.service.ts